<template>
  <section class="address-form">
    <el-form
      ref="form"
      :model="formData"
      :disabled="disabled"
      :rules="isRules?rules:{}">
      <slot name="extra"></slot>
      <span
        class="title">Risk Location</span>
      <div class="form-flex">
        <div class="form-block error__none">
          <span>Room</span>
          <el-form-item
            ref="addr_room"
            prop="addr_room">
            <v-input
              v-model="formData.addr_room"
              key-address
              maxlength="5"
              @blur="handleUpdateRoom"/>
            <template slot="{error}"></template>
          </el-form-item>
        </div>
        <div class="form-block error__none">
          <span>Floor</span>
          <el-form-item
            ref="addr_floor"
            prop="addr_floor">
            <v-input
              v-model="formData.addr_floor"
              key-address
              maxlength="5"
              @blur="handleUpdateFloor"/>
            <template slot="{error}"></template>
          </el-form-item>
        </div>
        <div class="form-block error__none">
          <span>Block</span>
          <el-form-item
            ref="addr_block"
            prop="addr_block">
            <v-input
              v-model="formData.addr_block"
              key-address
              maxlength="5"
              @blur="handleUpdateBlock"/>
          </el-form-item>
        </div>
      </div>
      <div class="form-block error__none">
        <span>Building / Estate</span>
        <el-form-item
          ref="addr_building"
          prop="addr_building">
          <v-input
            v-model="formData.addr_building"
            key-address
            @blur="handleUpdateBuild"/>
        </el-form-item>
      </div>
      <div class="form-block">
        <span>Street</span>
        <el-form-item
          ref="addr_street"
          prop="addr_street">
          <v-input
            v-model="formData.addr_street"
            key-address
            @blur="handleUpdateStreet"/>
        </el-form-item>
      </div>

      <div
        class="form-flex">
        <div class="form-block">
          <span>District</span>
          <el-form-item
            ref="addr_district"
            prop="addr_district">
            <v-select
              v-model="formData.addr_district"
              :list="allOptions.area.district"
              @change="changeDistrict" />
          </el-form-item>
        </div>
        <div class="form-block">
          <span>Area</span>
          <el-form-item
            ref="addr_area"
            prop="addr_area">
            <v-select
              v-model="formData.addr_area"
              :list="allOptions.area.area"
              @change="changeArea" />
          </el-form-item>
        </div>
        <div class="form-block">
          <span>Country / Region</span>
          <el-form-item
            ref="addr_region"
            prop="addr_region">
            <v-select
              v-model="formData.addr_region"
              :list="allOptions.area.region"
              @change="changeRegion" />
          </el-form-item>
        </div>

      </div>

    </el-form>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'

export default {
  name: 'PetAddressForm',
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: [Object,Array],
      default: () => ({})
    },
    formType: {
      type: Number,
      default: 0
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allRequired: {
      type: Boolean,
      default: false
    },
    notValid: {
      type: Boolean,
      default: false
    },
    edit: {
      type: Boolean,
      default: false
    },
    isRules:{
      type:Boolean,
      default:true
    },
    addrNoRequire:{
      type: Boolean,
      default: false
    },
    isUpdate:{
      type: Boolean,
      default: false
    },
    room:{
      type: String,
      default: ''
    },
    floor:{
      type: String,
      default: ''
    },
    block:{
      type: String,
      default: ''
    },
    build:{
      type: String,
      default: ''
    },
    area:{
      type: [String,Number],
      default: ''
    },
    street:{
      type: String,
      default: ''
    },
    district:{
      type: [String,Number],
      default: ''
    },
    region:{
      type: [String,Number],
      default: ''
    },
  },
  data() {
    const checkAddress = (rule, value, callback) => {
      let {addr_room,addr_floor,addr_block,addr_building,addr_street} = this.formData||{}
      let arr =[
        addr_room,
        addr_floor,
        addr_block,
        addr_building,
        addr_street
      ]
      if(this.notValid) {
        callback()
      }
      let isNullNum = 0
      arr.filter(item=>{
        if(!!item){
          isNullNum = isNullNum+1
        }
      })
      if(isNullNum==0) {
        callback(new Error('Fill in at least one of the address fields'))
      }
      callback()
    }

    const checkAddrRequired = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      if(this.notValid) {
        callback()
      }
      if(this.allRequired && !valueResult) {
        callback(new Error(this.$t('placeholder.input')))
      }
      callback()
    }
    const checkRequired = (rule, value, callback) => {
      if(this.addrNoRequire){
        callback()
      }
      const valueResult = value !== null && value !== ''
      if(this.notValid) {
        callback()
      }
      const require = this.isRequired && this.requireValid

      if(require && !valueResult) {
        callback(new Error(this.$t('placeholder.input')))
      }
      callback()
    }
    return {
      oldFormDataLock: -1,
      isInit:false,
      formData: {
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
      },
      extraRules: {
        addr_room: [
          { validator: checkAddress, trigger: ['change', 'blur'] }
        ],
        addr_floor: [
          { validator: checkAddress, trigger: ['change', 'blur'] }
        ],
        addr_block: [
          { validator: checkAddress, trigger: ['change', 'blur'] }
        ],
        addr_building: [
          { validator: checkAddress, trigger: ['change', 'blur'] }
        ],
        addr_street: [
          { validator: checkAddress, trigger: ['change', 'blur'] }
        ],
        addr_district: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
        ],
        addr_area: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
        ],
        addr_region: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
        ],
      }
    }
  },
  computed:{
    addressValid(){
      let {addr_room,addr_floor,addr_block,addr_building,addr_street} = this.formData||{}
      let arr =[
        addr_room,
        addr_floor,
        addr_block,
        addr_building,
        addr_street
      ]
      if(this.notValid) {
        return true
      }
      let isNullNum = 0
      arr.filter(item=>{
        if(!!item){
          isNullNum = isNullNum+1
        }
      })
      return isNullNum>0?true:false
    }
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        if(this.formDataLock !== this.oldFormDataLock) {
          // 觸發更新就賦值，避免二次更新
          this.oldFormDataLock = this.formDataLock
          Object.keys(this.formData).some(key => {
            if(key in val) {
              this.formData[key] = val[key]
            }
          })
        }
        // this.formData = JSON.parse(JSON.stringify(this.formData))
      }
    },
    // formData:{
    //   immediate:true,
    //   deep:true,
    //   handler(val){
    //     if(this.isUpdate){
    //       this.$emit('update',val)
    //     }
    //   }
    // },
    addressValid:{
      immediate:true,
      handler(val){
        this.$nextTick(()=>{
          if(this.$refs.form){
            if(!val&&this.isInit){
              this.$refs.form.validateField(['addr_room','addr_floor','addr_block','addr_building','addr_street','addr_district'])
            }
            else  this.$refs.form.clearValidate(['addr_room','addr_floor','addr_block','addr_building','addr_street','addr_district'])
            this.isInit = true
          }
        })
      }
    }
  },
  methods: {
    handleUpdateStreet(){
      this.$emit('update:street',this.formData.addr_street)
    },
    handleUpdateBuild(){
      this.$emit('update:build',this.formData.addr_building)
    },
    handleUpdateRoom(){
      this.$emit('update:room',this.formData.addr_room)
    },
    handleUpdateFloor(){
      this.$emit('update:floor',this.formData.addr_floor)
    },
    handleUpdateBlock(){
      this.$emit('update:block',this.formData.addr_block)
    },
    async submitForm(formName) {
      await new Promise((resolve, reject) => {
        this.$refs['form'].validate((valid, rules) => {
          if(valid) {
            this.$emit('update:street',this.formData.addr_street)
            this.$emit('update:build',this.formData.addr_building)
            this.$emit('update:room',this.formData.addr_room)
            this.$emit('update:floor',this.formData.addr_floor)
            this.$emit('update:block',this.formData.addr_block)
            this.$emit('update:area',this.formData.addr_area)
            this.$emit('update:district',this.formData.addr_district)
            this.$emit('update:region',this.formData.addr_region)
            this.$emit('getFormData', formName)
            resolve(valid)
          } else {
            this.scrollToValidDom(rules)
            reject(valid)
          }
        })
      })
    },

    submitFormNoVaild(formName) {
      this.$emit('update:street',this.formData.addr_street)
      this.$emit('update:build',this.formData.addr_building)
      this.$emit('update:room',this.formData.addr_room)
      this.$emit('update:floor',this.formData.addr_floor)
      this.$emit('update:block',this.formData.addr_block)
      this.$emit('update:area',this.formData.addr_area)
      this.$emit('update:district',this.formData.addr_district)
      this.$emit('update:region',this.formData.addr_region)
      this.$emit('getFormData', formName)
    },
    clearValidate() {
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },

    changeDistrict(id) {
      let { addr_area, addr_region } = this.formData
      const pid = this.getAreaData('district', id).pid
      // 檢查 area
      if(addr_area !== pid) {
        this.formData.addr_area = pid
      }
      // 檢查 region
      const areaPid = this.getAreaData('area', pid).pid
      if(addr_region !== areaPid) {
        this.formData.addr_region = areaPid
      }
      this.$emit('update:district',this.formData.addr_district)
      this.$emit('update:region',this.formData.addr_region)
    },
    changeArea(id) {
      let { addr_region, addr_district } = this.formData
      const pid = this.getAreaData('area', id).pid
      if(addr_region !== pid) {
        this.formData.addr_region = pid
      }
      const districtPid = this.getAreaData('district', addr_district).pid
      if(districtPid !== id) {
        this.formData.addr_district = ''
      }
      this.$emit('update:area',this.formData.addr_area)
      this.$emit('update:district',this.formData.addr_district)
      this.$emit('update:region',this.formData.addr_region)
    },
    changeRegion(id) {
      const areaPid = this.getAreaData('area', this.formData.addr_area).pid
      if(areaPid !== id) {
        this.formData.addr_area = ''
        this.formData.addr_district = ''
      }
      this.$emit('update:area',this.formData.addr_area)
      this.$emit('update:district',this.formData.addr_district)
      this.$emit('update:region',this.formData.addr_region)
    },
  }
}
</script>
<style lang="scss" scoped>
.address-form {
  .mgb-5 {
    margin-bottom: 5px;
  }
  .form-block {
    margin-bottom: 15px;
    & > span:first-child {
      display: block;
      padding-bottom: 5px;
      color: #616266;
      font-weight: 500;
      font-size: 14px;
    }
  }
  .title {
    display: block;
    padding-bottom: 15px;
    color: $dark;
    font-size: 16px;
    font-weight: 600;
  }
  .form-flex {
    display: flex;
    justify-content: space-between;
    & > .form-block {
      margin-right: 15px;
      flex: 1;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
/deep/.error__none{
  .el-form-item__error{
    display: none;
  }
}
</style>
